/// <reference path="../_references.ts"/>
module App.Dashboard {

	export class DashboardService {

		constructor(
			public $http: ng.IHttpService,
			public Constants: IConstants
		){ }

		public getStats(techId: number, start: Date, end: Date): ng.IHttpPromise<TechStats> {
			return this.$http.get(`${this.Constants.apiUrl}technician/${techId}/stats`, {
				params: {
					start: moment(start).format('YYYY-MM-DD'),
					end: moment(end).format('YYYY-MM-DD')
				}
			});
		}

		static factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) =>
				new DashboardService($http, Constants);

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}